import useDBO from '../../hooks/useDBO';
import Loading from "../../Loading";
import Error from "../../components/Error";
import Staff from '../../components/Staff';
import { useNavigate } from 'react-router-dom';
import { Lesson, Syllabus } from './types';
  
  export default function Issues() {

  const data = useDBO<Syllabus>(`/syllabus-issues`)

  if(data.loading) return <Loading />
  if(data.error) return <Error />
  
 data.log()

    return (<div>{
       data.map(syllabus => <DrawLessons syllabus={syllabus} key={syllabus._id} />)
  }</div>)
};
  

function DrawLessons({ syllabus }: { syllabus: Syllabus }) {
  
  return (
    <div>
      <div>{syllabus.name}</div>
      {syllabus.lessons.map(lesson=> <DrawIssues lesson={lesson} /> )}
     
    </div>
  );
}

function DrawIssues({ lesson }: {lesson: Lesson}) {

  const navigate = useNavigate()
  return (
    <div onClick={()=>navigate(`/teaching/syllabus/${lesson.syllabus}/unit/${lesson.unit}/lesson/${lesson._id}`)} className="cursor-pointer hover:bg-gray-300">
      Lesson: {lesson.lessonNumber}, {lesson.name}
      {lesson.issuesDetail.filter(i=>!i.resolutionDate).map((issue) => 
        <div className="text-xs">
                <div>Reported by <Staff id={issue.createdBy} /> at {new Date(issue.createdAt).fTime()} on {new Date(issue.createdAt).fDate()}
                </div>
                <div className="text-sm">{issue.description}</div>
        </div>
      )}
    </div>
  );
}